import * as React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import EventIcon from "@material-ui/icons/Event";
import ViewListIcon from "@material-ui/icons/ViewList";
import { ScheduleView } from "../../hooks/useScheduleView";

const options: { key: ScheduleView; label: string; Icon: typeof EventIcon }[] = [
  { key: "calendar", label: "Calendar", Icon: EventIcon },
  { key: "list", label: "List", Icon: ViewListIcon },
];

/** Page-level view switch. Replaces the calendar's own day/week tabs. */
export const ScheduleViewTabs: React.FC<{
  value: ScheduleView;
  onChange: (next: ScheduleView) => void;
}> = ({ value, onChange }) => (
  <Tabs
    value={value}
    onChange={(_event, next) => onChange(next as ScheduleView)}
    variant="fullWidth"
    indicatorColor="primary"
    textColor="primary"
    aria-label="Schedule view"
    style={{ minHeight: 40 }}
  >
    {options.map((option) => (
      <Tab
        key={option.key}
        value={option.key}
        label={
          <span className="flex items-center justify-center gap-1">
            <option.Icon style={{ fontSize: 16 }} />
            {option.label}
          </span>
        }
        style={{ minHeight: 40, fontSize: 12, minWidth: 0, textTransform: "none" }}
      />
    ))}
  </Tabs>
);
